import { useLocation } from "react-router-dom";
import { bookReviewDescriptionMap, bookReviewTitlesMap } from "./constants";
import ConstructionPage from "./ConstructionPage";
export const Article = () => {
    const { state } = useLocation();
    if (state.name === undefined) {
        return (
            <ConstructionPage />
        )
    }
    return (
        <div className="flex flex-col">
            <div className="w-10/12 bg-slate-400 self-center mt-10 rounded-lg h-10 text-center pt-2 font-bold">{bookReviewTitlesMap[state.name]}</div>
            <div className="drop-shadow-lg bg-slate-300 w-10/12 pb-5 mb-10  self-center mt-10 pl-5 pr-5 pt-5 rounded-lg flex flex-col">{bookReviewDescriptionMap[state.name]}</div>
        </div>
    )
};

export default Article;